import type { GettextInterface } from "@indeed/indeed-gettext";

export const eventLocaleTimeFormatter = (
  eventISO: string,
  eventLocale: string,
  gt: GettextInterface,
): string => {
  // strip offset off of event ISO string and make it UTC
  const utcISO = eventISO.replace(/[+-]\d{2}:\d{2}$/, "Z");
  const utcTS = new Date(utcISO).getTime();
  const userOffsetInMS = new Date(utcTS).getTimezoneOffset() * 60 * 1000;

  const localizedTime = new Date(utcTS + userOffsetInMS).toLocaleTimeString(eventLocale, {
    hour: "numeric",
    minute: "numeric",
  });

  return gt.pgettext("localized time", "{0}", [localizedTime]);
};

export const getTimezoneName = (dateIso: string, locale: string, timeZone: string): string => {
  return (
    Intl.DateTimeFormat(locale, {
      timeZone,
      timeZoneName: "long",
    })
      .formatToParts(new Date(dateIso))
      .find(({ type }) => type === "timeZoneName")?.value || timeZone
  );
};

export const formatShortDateTimeRange = (
  startISO: string,
  endISO: string,
  locale: string,
  timeZone: string,
): string => {
  const startDate = new Date(startISO);
  const startDateStr = Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone,
  }).format(startDate);
  let startTimeStr = Intl.DateTimeFormat(locale, {
    hour: "numeric",
    timeZone,
    ...(startDate.getMinutes() ? { minute: "numeric" } : {}),
  })
    .format(startDate)
    .toLowerCase();

  const endDate = new Date(endISO);
  const endTimeStr = Intl.DateTimeFormat(locale, {
    hour: "numeric",
    timeZone,
    ...(endDate.getMinutes() ? { minute: "numeric" } : {}),
  })
    .format(endDate)
    .toLowerCase();

  const maybeAmPm = startTimeStr.match(/ [ap]m$/)?.[0];
  if (maybeAmPm && maybeAmPm === endTimeStr.substr(-3)) {
    startTimeStr = startTimeStr.substring(0, startTimeStr.length - 3);
  }

  return `${startDateStr} | ${startTimeStr}–${endTimeStr}`;
};
